export type ActivationMessages = {
  formTitle: string;
  submitButton: string;

  // Subtitles
  registrationDataSubtitle: string;
  addressSubtitle: string;

  // Labels
  documentLabel: string;
  nameLabel: string;
  emailLabel: string;
  mobilePhoneLabel: string;
  birthDateLabel: string;
  companyTypeLabel: string;
  incomeValueLabel: string;
  addressLabel: string;
  addressNumberLabel: string;
  complementLabel: string;
  provinceLabel: string;
  cityLabel: string;
  stateLabel: string;
  cepLabel: string;
  phoneLabel: string;
  // Placeholders
  documentPlaceholder: string;
  namePlaceholder: string;
  emailPlaceholder: string;
  mobilePhonePlaceholder: string;
  birthDatePlaceholder: string;
  companyTypePlaceholder: string;
  incomeValuePlaceholder: string;
  addressPlaceholder: string;
  addressNumberPlaceholder: string;
  complementPlaceholder: string;
  provincePlaceholder: string;
  cityPlaceholder: string;
  statePlaceholder: string;
  cepPlaceholder: string;
  phonePlaceholder: string;
  // Error messages
  errorRequiredDocument: string;
  errorInvalidDocument: string;
  errorRequiredName: string;
  errorInvalidEmail: string;
  errorRequiredEmail: string;
  errorRequiredMobilePhone: string;
  errorRequiredCompanyType: string;
  errorInvalidCompanyType: string;
  errorRequiredIncomeValue: string;
  errorInvalidIncomeValue: string;
  errorRequiredAddress: string;
  errorRequiredAddressNumber: string;
  errorRequiredProvince: string;
  errorRequiredCEP: string;
  errorRequiredCity: string;
  errorRequiredState: string;
  errorRequiredPhone: string;
  errorRequiredBirthDate: string;
  cepNotFoundError: string;
  errorCreateAccount: string;

  // Company Type Labels
  companyTypeMEILabel: string;
  companyTypeLimitedLabel: string;
  companyTypeIndividualLabel: string;
  companyTypeAssociationLabel: string;
  // Additional messages

  termsOfUseMessagePart1: string;
  termsOfUseLinkText: string;
  termsOfUseMessagePart2: string;
};

export const activationMessages: ActivationMessages = {
  formTitle: "Cadastre aqui as informações de acesso ao seu Painel Financeiro e Conta Digital",
  // Subtitles
  // Subtitles
  registrationDataSubtitle: "Dados Cadastrais",
  addressSubtitle: "Endereço",

  submitButton: "Enviar",
  // Labels
  documentLabel: "CPF/CNPJ",
  nameLabel: "Razão Social",
  emailLabel: "Email",
  mobilePhoneLabel: "Telefone Celular",
  birthDateLabel: "Data de Nascimento",
  companyTypeLabel: "Tipo Empresarial",
  incomeValueLabel: "Faturamento Mensal (R$)",
  addressLabel: "Endereço",
  addressNumberLabel: "Número",
  complementLabel: "Complemento",
  provinceLabel: "Bairro",
  cityLabel: "Cidade",
  stateLabel: "Estado",
  cepLabel: "CEP",
  phoneLabel: "Telefone Fixo",
  // Placeholders
  documentPlaceholder: "000.000.000-00 ou 00.000.000/0000-00",
  namePlaceholder: "Razão Social",
  emailPlaceholder: "email@exemplo.com",
  mobilePhonePlaceholder: "(00) 00000-0000",
  birthDatePlaceholder: "Data de Nascimento",
  companyTypePlaceholder: "Selecione o Tipo Empresarial",
  incomeValuePlaceholder: "0,00",
  addressPlaceholder: "Endereço",
  addressNumberPlaceholder: "Número",
  complementPlaceholder: "Complemento",
  provincePlaceholder: "Bairro",
  cityPlaceholder: "Cidade",
  statePlaceholder: "Estado",
  cepPlaceholder: "00000-000",
  phonePlaceholder: "(00) 0000-0000",
  // Error messages
  errorRequiredDocument: "O CPF/CNPJ é obrigatório",
  errorInvalidDocument: "O CPF/CNPJ é inválido",
  errorRequiredName: "O nome é obrigatório",
  errorInvalidEmail: "O email é inválido",
  errorRequiredEmail: "O email é obrigatório",
  errorRequiredMobilePhone: "O telefone celular é obrigatório",
  errorRequiredCompanyType: "O tipo empresarial é obrigatório",
  errorInvalidCompanyType: "O tipo empresarial é inválido",
  errorRequiredIncomeValue: "O faturamento mensal é obrigatório",
  errorInvalidIncomeValue: "O faturamento mensal deve ser maior que zero",
  errorRequiredAddress: "O endereço é obrigatório",
  errorRequiredAddressNumber: "O número do endereço é obrigatório",
  errorRequiredProvince: "O bairro é obrigatório",
  errorRequiredCEP: "O CEP é obrigatório",
  errorRequiredCity: "A cidade é obrigatória",
  errorRequiredState: "O estado é obrigatório",
  errorRequiredPhone: "O telefone fixo é obrigatório",
  errorRequiredBirthDate: "A data de nascimento é obrigatória",
  cepNotFoundError: "Digite um CEP válido",
  errorCreateAccount: "Erro ao criar conta",

  // Company Type Labels
  companyTypeMEILabel: "Microempreendedor Individual (MEI)",
  companyTypeLimitedLabel: "Empresa Limitada (LTDA)",
  companyTypeIndividualLabel: "Empresário Individual",
  companyTypeAssociationLabel: "Associação",
  // Additional messages
  termsOfUseMessagePart1:
    "A utilização do Talk2Pay envolve a contratação de serviços prestados por terceiros. Ao clicar em Ativar você concorda com os ",
  termsOfUseLinkText: "termos de uso",
  termsOfUseMessagePart2: ", nosso parceiro na oferta deste recurso.",
};
